<div class="img-success"></div>

<div class="place-items">
  <h3>Created successfully!</h3>
</div>
<div class="button-container">
  <button (click)="closeModal()" class="confirm-button">OK</button>
</div>
